import { render, staticRenderFns } from "./PartnerSSOPage.vue?vue&type=template&id=5b8867a3&scoped=true"
import script from "./PartnerSSOPage.vue?vue&type=script&lang=ts"
export * from "./PartnerSSOPage.vue?vue&type=script&lang=ts"
import style0 from "./PartnerSSOPage.vue?vue&type=style&index=0&id=5b8867a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8867a3",
  null
  
)

export default component.exports